import { createFeedbackQuestionService, defaultFeedbackService, useDynamicConfig, useHasPermission } from "@dgs/core";
import { FC, useMemo } from "react";
import { useParams } from "react-router";
import { FeedbackDetailsWithPreview } from "./FeedbackDetailsWithPreview";

export const AdminFeedbackDetailsPage: FC = () => {
	const { feedbackId = "" } = useParams<{ feedbackId: string }>();
	const { frontendUrl } = useDynamicConfig();
	const canUpdate = useHasPermission(["feedback.update"]);
	const canDelete = useHasPermission(["feedback.delete"]);
	const feedbackQuestionService = useMemo(() => createFeedbackQuestionService([], feedbackId), [feedbackId]);

	return (
		<FeedbackDetailsWithPreview
			feedbackId={feedbackId}
			feedbackService={defaultFeedbackService}
			feedbackQuestionService={feedbackQuestionService}
			canUpdate={canUpdate}
			canDelete={canDelete}
			previewUrl={`${frontendUrl}/feedbacks/${feedbackId}/preview`}
		/>
	);
};
